import { render, staticRenderFns } from "./ResourceTile.vue?vue&type=template&id=7d0f1ea2&scoped=true"
import script from "./ResourceTile.vue?vue&type=script&lang=js"
export * from "./ResourceTile.vue?vue&type=script&lang=js"
import style0 from "./ResourceTile.vue?vue&type=style&index=0&id=7d0f1ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0f1ea2",
  null
  
)

export default component.exports